import { createContext, useContext, useMemo, useState } from "react";

export const DesignCardsContext = createContext();

export function DesignCardsProvider({ children }) {
  const [step, setStep] = useState(1);
  const [leftWidth, setLeftWidth] = useState(0);
  const [rightWidth, setRightWidth] = useState(0);
  const [leftPosition, setLeftPosition] = useState(0);
  const [rightPosition, setRightPosition] = useState(0);
  const [isEnded, setIsEnded] = useState(false);

  const value = useMemo(
    () => ({
      step,
      setStep,
      leftWidth,
      setLeftWidth,
      rightWidth,
      setRightWidth,
      leftPosition,
      setLeftPosition,
      rightPosition,
      setRightPosition,
      isEnded,
      setIsEnded,
    }),
    [step, leftWidth, rightWidth, leftPosition, rightPosition, isEnded]
  );

  return (
    <DesignCardsContext.Provider value={value}>
      {children}
    </DesignCardsContext.Provider>
  );
}

export function useDesignCards() {
  return useContext(DesignCardsContext);
}
